export const BASE_CLASS = 'mt-ListRatings'
export const NO_OP = () => {}

// Fixed locale and zone for the review dates: SSR runs with Node's defaults (en-US, UTC) and the browser with the
// user's, so an unlocalized date renders different text on each side and breaks hydration.
export const DATE_FORMAT_LOCALE = 'es-ES'
export const DATE_FORMAT_OPTIONS = {timeZone: 'Europe/Madrid'}
